<ion-content class="ion-padding">
  <section class="s-super-social">
    <usucampeao-header title="Cadastrar moradores com renda"></usucampeao-header>

    <ion-text>
      <p>
        Informe os dados dos <b>moradores com renda</b> deste imóvel, para comprovação da renda familiar.
      </p>
    </ion-text>

    <div class="s-super-social__list">
      <usucampeao-morador-com-renda-card *ngFor="let morador of  moradoresComRenda$ | async" [cadastroId]="cadastroId"
        [morador]="morador"></usucampeao-morador-com-renda-card>
    </div>


    <div class="s-super-social__flex">
      <ion-button class="ion-margin-top" mode="md" fill="outline" (click)="adicionarNovoMoradorComRenda()">
        + Adicionar morador com renda
      </ion-button>
    </div>

    <div class="s-super-social__divider"></div>

    <div class="s-super-social__footer">
      <usucampeao-footer>
        <ion-button class="ion-margin-bottom" mode="md" [disabled]="!(moradoresComRenda$ |async)?.length"
          (click)="confirmarMoradores()">
          Confirmar moradores
        </ion-button>
        <ion-button mode="md" fill="outline" color="danger" (click)="cancelarProgramaSuperSocial()">
          Cancelar participação no programa
        </ion-button>
      </usucampeao-footer>
    </div>
  </section>
</ion-content>